import { render, staticRenderFns } from "./ProjectsListTable.vue?vue&type=template&id=4648a6c6"
import script from "./ProjectsListTable.vue?vue&type=script&lang=js"
export * from "./ProjectsListTable.vue?vue&type=script&lang=js"
import style0 from "./ProjectsListTable.vue?vue&type=style&index=0&id=4648a6c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports